import React, { useMemo } from "react";
import { constraints, datatypes, inputTypes } from "data/globalData";
import SelectInputField from "./InputComponents/SelectInputField";
import TextInputField from "./InputComponents/TextInputField";
import { grey } from "@mui/material/colors";
import { constraintsOptions } from "components/PimDashboard/data";

// Stable styles (no inline objects per render)
const textInputStyles = {
	width: "100%",
	fontWeight: 400,
	overflow: "hidden",
	boxSizing: "border-box",
};
const selectInputStyles = {
	width: "100%",
	fontWeight: 400,
	overflow: "hidden",
};

const RenderInputField = React.memo(
	({
		column,
		setData,
		data,
		width = "30%",
		longWidth = "60%",
		selectOptObjName,
		dependencyColData,
		multiple,
		onChangeCallBack,
		error = false,
		hideLabel = false,
		...rest
	}) => {
		const options = column[selectOptObjName] ? column[selectOptObjName] : { type: "objType", list: {} };

		const handleChange = (e) => {
			const value = e.target.value;

			setData((prev) => {
				const updated = { ...prev, [column.key]: value };

				if (typeof dependencyColData === "object") {
					Object.keys(dependencyColData)?.forEach((element) => {
						if (column.key === element) {
							updated[dependencyColData[element].col.key] = dependencyColData[element].val(
								element,
								value,
								dependencyColData[element].col.key,
								options,
							);
						}
					});
				}

				if (typeof onChangeCallBack === "function") {
					onChangeCallBack(e, value, updated);
				}

				return updated;
			});
		};

		if (!column) return null;

		if (column.input_type === inputTypes.ENTER.key || column.input_type === inputTypes.AUTO_GENERATE.key) {
			return (
				<TextInputField
					sx={{
						...textInputStyles,
						background: column?.input_type === inputTypes.AUTO_GENERATE.key ? grey[300] : grey[50],
					}}
					error={error}
					data={data}
					disabled={column?.input_type === inputTypes.AUTO_GENERATE.key}
					setData={setData}
					onChange={handleChange}
					column={column}
					width={
						column?.data_type === datatypes.LONGTEXT.key || column?.input_type === inputTypes.MULTIPLE_SELECT.key
							? longWidth
							: width
					}
					required={!!column?.constraints[constraintsOptions.NOTNULL.key]}
					type={column?.data_type}
					// InputProps={{ sx: { borderRadius: "0px 2px 2px 0px" } }}
					{...rest}
					disableLabel={hideLabel}
				/>
			);
		}

		return (
			<SelectInputField
				sx={{
					...selectInputStyles,
					background: grey[50],
				}}
				data={data}
				setData={setData}
				column={column}
				width={
					column?.data_type === datatypes.LONGTEXT.key || column?.input_type === inputTypes.MULTIPLE_SELECT.key
						? longWidth
						: width
				}
				onChange={handleChange}
				options={options}
				required={!!column?.constraints[constraintsOptions.NOTNULL.key]}
				disabled={column?.input_type === inputTypes.AUTO_GENERATE.key}
				multiple={multiple || column?.input_type === inputTypes.MULTIPLE_SELECT.key}
				error={error}
				{...rest}
				disableLabel={hideLabel}
			/>
		);
	},
);

export default RenderInputField;
